"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
exports.default = createIconComponent_1.default("Search", React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M1.78993 21.90267l6.50532-6.50532.7071.7071-6.50532 6.50532z" }),
    React.createElement("path", { d: "M8.2 14.6L1 21.9l1.4 1.4 7.3-7.2zM8.9 15.5l1.5-1.4z" }),
    React.createElement("path", { d: "M10.3 13.4l-2.2 2.2.8.7 2.2-2.2z" }),
    React.createElement("circle", { cx: "15", cy: "8.5", r: "6.9", fill: "none", stroke: "currentColor" })));
//# sourceMappingURL=Search.js.map